var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "animated fadeIn" },
    [
      _c("SearchBar", {
        attrs: { title: _vm.$t("ROUTE_NAME.Log History") },
        on: { filterInput: _vm.setFilter }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "logs-table" },
        [
          _vm.logsLoaded
            ? _c("b-table", {
                attrs: {
                  striped: "",
                  hover: "",
                  "show-empty": "",
                  filter: _vm.filter,
                  "empty-text": _vm.$t("COMMON.NO_RECORD"),
                  responsive: "sm",
                  items: _vm.getTrailsData,
                  fields: _vm.tableFields,
                  "sort-by": _vm.sortBy,
                  "sort-desc": _vm.sortDesc
                },
                on: {
                  "update:sortBy": function($event) {
                    _vm.sortBy = $event
                  },
                  "update:sortDesc": function($event) {
                    _vm.sortDesc = $event
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "HEAD_action",
                    fn: function(data) {
                      return [_c("em", [_vm._v(_vm._s(_vm.$t(data.label)))])]
                    }
                  },
                  {
                    key: "HEAD_path",
                    fn: function(data) {
                      return [_c("em", [_vm._v(_vm._s(_vm.$t(data.label)))])]
                    }
                  },
                  {
                    key: "HEAD_location",
                    fn: function(data) {
                      return [_c("em", [_vm._v(_vm._s(_vm.$t(data.label)))])]
                    }
                  },
                  {
                    key: "HEAD_logged_at",
                    fn: function(data) {
                      return [_c("em", [_vm._v(_vm._s(_vm.$t(data.label)))])]
                    }
                  }
                ])
              })
            : _c(
                "b-card",
                [
                  _c(
                    "content-placeholders",
                    [
                      _c("content-placeholders-img", {
                        style: { height: "400px" }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
          _vm._v(" "),
          _c(
            "infinite-loading",
            {
              ref: "infiniteLoading",
              attrs: { distance: _vm.distance, spinner: "spiral" },
              on: { infinite: _vm.infiniteHandler }
            },
            [
              _c("div", { attrs: { slot: "no-more" }, slot: "no-more" }),
              _vm._v(" "),
              _c("div", { attrs: { slot: "no-results" }, slot: "no-results" })
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "downloadLogsModal",
          attrs: {
            "hide-header-close": "",
            title: _vm.$t("TRAILS.CUSTOM_DATE_LOGS"),
            "header-bg-variant": "light",
            centered: ""
          }
        },
        [
          _c(
            "b-card",
            [
              _c(
                "b-row",
                { staticClass: "mb-3" },
                [
                  _c("b-col", { attrs: { cols: "3" } }, [
                    _vm._v(" " + _vm._s(_vm.$t("COMMON.DATE_RANGE")) + " ")
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "mt-auto", attrs: { sm: "4" } },
                    [
                      _c("date-picker", {
                        attrs: {
                          range: "",
                          lang: "en",
                          format: "YYYY-MM-DD",
                          clearable: false,
                          width: "220px",
                          confirm: "",
                          click: _vm.verifyDateRange()
                        },
                        model: {
                          value: _vm.dateRange,
                          callback: function($$v) {
                            _vm.dateRange = $$v
                          },
                          expression: "dateRange"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.verifyDays
                ? _c("p", { staticStyle: { color: "red" } }, [
                    _vm._v(_vm._s(_vm.$t("COMMON.MSG_CSV_LOG_DAYS_ERROR")))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("p", { staticStyle: { "text-align": "left", color: "red" } }, [
                _vm._v(" * " + _vm._s(_vm.$t("COMMON.MSG_CSV_LOG_DAYS")))
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "modal-footer" }, slot: "modal-footer" },
            [
              _c(
                "b-btn",
                {
                  attrs: {
                    size: "sm",
                    variant: "secondary",
                    disabled: _vm.verifyDays
                  },
                  on: {
                    click: function($event) {
                      _vm.download_logs()
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("COMMON.GENERATE")) + " ")]
              ),
              _vm._v(" "),
              _c(
                "b-btn",
                {
                  attrs: { size: "sm", variant: "light" },
                  on: { click: _vm.hidedownloadLogsModal }
                },
                [_vm._v(" " + _vm._s(_vm.$t("COMMON.CLOSE")) + " ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-79f35aa9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79f35aa9","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/audits/Trail.vue
// module id = 1270
// module chunks = 2